import { createContext, useContext, useEffect, useState } from "react"
import { useViewMode } from "./ViewModeContext"

const PinnedSidebarContext = createContext()

export const PinnedSidebarProvider = ({ children }) => {
    const { viewMode } = useViewMode()
    const isTableView = viewMode === "table_view"
    const [isMobileOpen, setIsMobileOpen] = useState(false)

    const toggleMobileSidebar = () => setIsMobileOpen((prev) => !prev)
    const closeMobileSidebar = () => setIsMobileOpen(false)

    const [isPinned, setIsPinned] = useState(() => {
        return localStorage.getItem("sidebarPinned") === "true"
    })

    // Keep localStorage in sync whenever isPinned changes
    useEffect(() => {
        localStorage.setItem("sidebarPinned", String(isPinned))
    }, [isPinned])

    const togglePin = () => {
        setIsPinned((prev) => !prev)
    }

    const isSticky = isPinned

    return (
        <PinnedSidebarContext.Provider
            value={{
                isPinned,
                setIsPinned,
                togglePin,
                isTableView,
                isSticky, // <--- use this in UI
                isMobileOpen,
                toggleMobileSidebar,
                closeMobileSidebar,
            }}
        >
            {children}
        </PinnedSidebarContext.Provider>
    )
}

export const usePinnedSidebar = () => useContext(PinnedSidebarContext)
